import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { fleetEnvironment } from './fleet-environment';

export function postVehicleGroupsVehiclesCombinedAssignment(
  vehicleGroupId: number,
  assignmentVehicleIds: string[],
  unassignmentVehicleIds: string[]
) {
  return fromFetch(
    new Request(
      fleetEnvironment.vehicleGroupsVehiclesCombinedAssignmentUrl(
        String(vehicleGroupId)
      ),
      {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...new FleetJwtAuthHeaders(),
        },
        body: JSON.stringify({
          assignmentVehicleIds,
          unassignmentVehicleIds,
        }),
      }
    )
  ).pipe(ignoreData());
}
